namespace cdh.notification {

    export enum ActivationState {
        Error = -1,
        Disabled = 0,
        Active = 1,
    }

    export interface INotificationFeatureConfig {
        state: ActivationState;

        // CompatibilityInfo
        isRepetitionEnabled: boolean;

        // ext Notifications
        baseUrl: string;
        accessToken: string;


    }

    function appendNotificationAuth(ajax: JQuery.AjaxSettings, xhr?: JQuery.jqXHR) {
        var cfg = notificationConfig();

        debugger;

        if (xhr) {
            xhr.setRequestHeader("Authorization", "Bearer " + cfg.accessToken);
        }
        else {
            var befSend = ajax.beforeSend;



            ajax.beforeSend = (xhr, settings) => {
                if (befSend) befSend(xhr, settings);

                xhr.setRequestHeader("Authorization", "Bearer " + cfg.accessToken);
            }
        }
    }
    $(document).ajaxSend((e, xhr, s) => {

        if (utils.startsWithIgnoreCase(s.url, Router.baseUrl))
            return;

        var cfg = notificationConfig();

        if (!utils.startsWithIgnoreCase(s.url, cfg.baseUrl))
            return;

        appendNotificationAuth(s, xhr);
    });

    export async function countNotifications(srcRef?: ITargetRef): Promise<number> {
        var url: string;

        if (notificationConfig.isExternal()) {
            var base = notificationConfig().baseUrl;
            var res: MappableObject = {
                controller: "simple",
                area: "notifications",
                action: "hasScheduled"
            }

            appendSourceRefRouteData(res, srcRef);

            url = utils.getExtUrl(base, data.apiUrls.areaControllerActionUrlBase, res);

        }
        else {
            var res: MappableObject = {
                action: "hasScheduled"

            }

            appendSourceRefRouteData(res, srcRef);


            url = data.apiUrls.getGenericRouteUrl(null, "notification", res);
        }

        if (url)
            return await utils.getSingle<number>(url);
        else return 0;
    }

    function appendSourceRefRouteData(rd: MappableObject, srcRef?: ITargetRef) {
        if (srcRef)
            if (srcRef.refType) {
                rd.refType = srcRef.refType;
                if (srcRef.refId)
                    rd.refId = srcRef.refId;
            }

        if (!rd.refType && !rd.refId && defaultRefType)
            rd.refType = defaultRefType;
    }

    export interface NotificationSearchModel {
        id: number;
        refType: string;
        refId: string;
        sourceUrl: string;
        schedulingType: number; //NotificationSchedulingType
        schedule: string;// DateTime
        status: string; //NotificationSchedulingStatus
        subject: string;
    }

    // TODO define Enum
    export enum NotificationRepetitionType {
        None = 0,
        Daily = 1,
        Weekly = 2,
        Biweekly = 3,
        Monthly = 4,
        Quarterly = 5,
        Yearly = 6,

        // Debug
        Hourly = 98,
        FiveMinutes = 99,
    }

    export const notificationRepetitionTypes = cdh.viewModels.EnumLookup.createLookup(viewModels.getEnumDefFunc(NotificationRepetitionType, "data/notifications/repetitionTypes."), [
        NotificationRepetitionType.None,
        NotificationRepetitionType.Daily,
        NotificationRepetitionType.Weekly,
        //NotificationRepetitionType.Biweekly,
        NotificationRepetitionType.Monthly,
        NotificationRepetitionType.Quarterly,
        NotificationRepetitionType.Yearly,

        //NotificationRepetitionType.Hourly,
        //NotificationRepetitionType.FiveMinutes,
    ]);

    var titleStatusActive = t2("data/notifications/status.active");
    var titleStatusComplete = t2("data/notifications/status.complete");
    var titleStatusInactive = t2("data/notifications/status.inactive");
    var titleStatusOther = t2("data/notifications/status.other");

    //export interface IRefTypeDefinition {
    //    name: string;
    //    displayName: ObservableOrValueReadonly<string>;

    //    format(refId: string): ObservableOrValueReadonly<string>;
    //}

    export var defaultRefType: string;
    export var defaultLink: ObservableOrValueReadonly<{ url: string, desc: string }>;
    //export const refTypes = new utils.SimpleStringKeyedCollection<IRefTypeDefinition>(def => def.name);

    export function getStatusDisplayName(status: number) {
        switch (status) {
            case 0:
                return titleStatusInactive;
            case 1:
                return titleStatusActive;
            case 4:
            case 5:
                return titleStatusComplete;

            default:
                return titleStatusOther;
        }
    }

    // TODO create definition
    export type INotificationModel = NotificationSearchModel & MappableObject;

    export type INotificationContainerModel = {
        header: INotificationModel;
    } & MappableObject;

    const notificationProps = new PropertyMapper<NotificationViewModel>([
        "id",
        "refType", "refId", "sourceUrl",

        { name: "schedule", handler: "date", mode: "dateTime" },
        "status",
        "subject", "body", "bodyType",

        "linkUrl", "linkDesc"
    ]).addModelProp();
    export class NotificationViewModel extends viewModels.ViewModelBase<NotificationViewModel>{

        readonly id: KnockoutObservable<number>;
        readonly refType: KnockoutObservable<string>;
        readonly refId: KnockoutObservable<string>;
        readonly sourceUrl: KnockoutObservable<string>;
        readonly schedule: KnockoutDateExtender;// DateTime
        readonly status: KnockoutObservable<number>; //NotificationSchedulingStatus
        readonly subject: KnockoutObservable<string>;
        readonly body: KnockoutObservable<string>;
        readonly bodyType: KnockoutObservable<number>;

        readonly linkUrl: KnockoutObservable<string>;
        readonly linkDesc: KnockoutObservable<string>;

        constructor(readonly parent: any, model?: MappableObject) {
            super(notificationProps, parent, model);
        }


    }

    const notificationContainerProps = new PropertyMapper<NotificationContainerViewModel>([
        { name: "header", handler: "block", type: NotificationViewModel },
    ]).addModelProp();
    export class NotificationContainerViewModel extends viewModels.ViewModelBase<NotificationContainerViewModel, INotificationContainerModel>{

        readonly header: NotificationViewModel;

        constructor(readonly parent: any, model?: Partial<INotificationContainerModel>) {
            super(notificationContainerProps, parent, model);
        }

    }



    const simpleNotificationProps = new PropertyMapper<SimplifiedNotificationViewModel>([
        ["id", 0],
        "recipient",

        ["repetition", 0], { name: "schedule", handler: "date", mode: "dateTime" }, { name: "endDate", handler: "date", mode: "dateTime" },
        "subject", "body",

        "linkUrl", "linkDesc"
    ]).addModelProp();
    export class SimplifiedNotificationViewModel extends viewModels.ViewModelBase<SimplifiedNotificationViewModel>{

        readonly id: KnockoutObservable<number>;

        readonly recipient: KnockoutObservable<string>;

        readonly repetition: KnockoutObservable<NotificationRepetitionType>; //NotificationRepetitionType
        readonly schedule: KnockoutDateExtender;// DateTime
        readonly endDate: KnockoutDateExtender;// DateTime

        readonly subject: KnockoutObservable<string>;
        readonly body: KnockoutObservable<string>;

        readonly linkUrl: KnockoutObservable<string>;
        readonly linkDesc: KnockoutObservable<string>;


        readonly config: KnockoutReadonlyObservable<INotificationFeatureConfig>;
        repetitionTypes: viewModels.EnumLookup<notification.NotificationRepetitionType>;

        constructor(readonly parent: any, model?: MappableObject) {
            super(simpleNotificationProps, parent, model);

            this.config = notificationConfig;
            this.repetitionTypes = notificationRepetitionTypes;
        }


    }

    export type NotificationSearchOptions = {
        showInactive: KnockoutObservable<boolean>;
        showCompleted: KnockoutObservable<boolean>;
        showScheduled: KnockoutObservable<boolean>;
    };

    export class SimpleNotificationEditorViewModel extends viewModels.EditorViewModelBase<SimplifiedNotificationViewModel, MappableObject, number, NotificationRepository>{

        readonly recipients: utils.IRecentTermsGroup;

        constructor(rep: NotificationRepository, owner?: any) {
            super(rep, SimplifiedNotificationViewModel, v => ko.unwrap(v.id), owner);

            this.recipients = utils.terms.getGroup("notifications/rcp");

        }

        async prepareSave(editMode: viewModels.EditorMode, key: number) {
            if (editMode == "edit" || editMode == "create") {
                var m = ko.unwrap(this.model);

                var start = m.schedule.state().value();
                var end = m.endDate.state().value();

                if (end && end.isValid()) {
                    var end2 = end.clone().startOf("d");
                    if (start && start.isValid()) {
                        end2.set({
                            hour: start.get("hour"),
                            minute: start.get("minute"),
                            second: start.get("second"),

                        });
                    }
                    m.endDate(end2);
                }


                var includeLink = true;

                var rcp = ko.unwrap(m.recipient);
                var defRcp = ko.unwrap(this.rep.defaultRecipient);
                includeLink = utils.equalsIgnoreCase(rcp, defRcp);

                if (includeLink) {

                    let lnk = ko.unwrap(this.rep.link || defaultLink);
                    if (lnk) {
                        m.linkUrl(lnk.url);
                        m.linkDesc(lnk.desc);
                    }

                } else {
                    m.linkUrl(null);
                    m.linkDesc(null);
                }

            }

        }

        async saveAdditional(editMode: viewModels.EditorMode, key: number) {
            if (editMode == "edit" || editMode == "create") {
                var m = ko.unwrap(this.model);
                if (m) {
                    var rcp = m.recipient();

                    if (rcp) this.recipients.addTerm(rcp);
                }
            }
        }

    }

    export class NotificationRepository extends viewModels.ApiDataRepository<MappableObject, number, NotificationSearchModel, SimplifiedNotificationViewModel>{

        static readonly editorDialogOptions: IDialogOptions = {
            template: { type: "id", value: "templates/core/notification-editor-simple" },
            size: "default",
            title: t2("data/notifications/title")


        };

        private readonly _cfg: INotificationFeatureConfig;

        constructor() {
            super();

            this._cfg = notificationConfig();

            if (!this._cfg || this._cfg.state != ActivationState.Active)
                throw new Error("NotificationService not Active");
        }

        ref?: ITargetRef;
        link?: ObservableOrValueReadonly<{ url: string, desc: string }>;

        getRouteDataBase(): MappableObject {
            var res: MappableObject = {
                controller: "simple",
                area: "notifications"
            }

            appendSourceRefRouteData(res, this.ref);

            return res;
        }

        getKeyFields(): DataSourceKey<NotificationSearchModel> {
            return "id";
        }
        getSearchUrl(): string {

            var base = this._cfg.baseUrl;

            var base = notificationConfig().baseUrl;
            var rd = this.getRouteDataBase()


            return utils.getExtUrl(base, data.apiUrls.areaControllerUrlBase, rd);
        }
        getGetUrl(key: number): string {

            var base = this._cfg.baseUrl;
            var rd = this.getRouteDataBase()
            rd.id = key;


            return utils.getExtUrl(base, data.apiUrls.areaControllerIdUrlBase, rd);
        }
        getInsertUrl(model?: NotificationSearchModel): string {
            var base = this._cfg.baseUrl;
            var rd = this.getRouteDataBase();

            if (!this.ref)
                throw new Error("Ref is Required for Inserting Notifications");


            return utils.getExtUrl(base, data.apiUrls.areaControllerUrlBase, rd);
        }

        createEditor(owner?: any): SimpleNotificationEditorViewModel {
            return new SimpleNotificationEditorViewModel(this, owner);
        }

        createDataSource(type?: viewModels.StringSearchTypeValues, term?: string): viewModels.ISearchableDataSource<NotificationSearchModel, number> {
            let ds = new viewModels.SearchableDataSource<NotificationSearchModel, number, NotificationSearchOptions>({
                baseUrl: ko.pureComputed(() => this.getSearchUrl()), key: this.getKeyFields(),
                searchOptions: { showInactive: ko.observable(false), showCompleted: ko.observable(false), showScheduled: ko.observable(true) },
                reloadOnOptionsChanged: true,
                beforeLoad: (ajax, o) => {
                    var types: string[] = [];
                    if (ko.unwrap(o.showScheduled))
                        types.push("scheduled");
                    if (ko.unwrap(o.showInactive))
                        types.push("inactive");
                    if (ko.unwrap(o.showCompleted))
                        types.push("completed");

                    if (typeof ajax.data === "object")
                        ajax.data.types = types;
                }
            }, type, term);

            if (this.getSearchName)
                ds.searchName(this.getSearchName());

            if (this.prepareDataSourceCommands)
                this.prepareDataSourceCommands(ds);

            return ds;
        }

        createSearcher() {
            var s = super.createSearcher() as viewModels.GenericSearcherViewModel<NotificationSearchModel, number>;

            s.showSearch = false;
            s.searchOptionsTemplate = { type: "id", value: "templates/core/notification-searchOptions" };

            s.commandHandler.addHandlersStart(new viewModels.PopupEditorCommandHandler(this, null, NotificationRepository.editorDialogOptions, this, s));

            return s;
        }

        defaultRecipient: ObservableOrValueReadonly<string> = ko.pureComputed(() => {
            var usr = userContext();
            if (usr && usr.email){
                return usr.email;
            }
            return null;
        });

        createNew() {
            var res: MappableObject = {};

            var rcp = ko.unwrap(this.defaultRecipient);
            if (rcp) {
                res.recipient = (rcp);
            }

            res.schedule = this.getAutoTime();

            if (this.ref) {
                res.refType = this.ref.refType;
                res.refId = this.ref.refId;
            }

            return res;

        }

        getAutoTime(dt?: moment.Moment|Date) {
            if (dt instanceof Date)
                dt = moment(dt);
            if (!moment.isMoment(dt) || !dt.isValid())
                dt = moment();

            var res = dt.clone();
            var now = moment();

            var min = now.minute();
            if (now.second() >= 30) min++;

            var mod = min % 15;
            if (mod > 15 / 2)
                min += 15 - mod;
            else
                min -= mod;

            now.set({ minute: 0, second: 0, millisecond: 0 });
            now.add(min + 60, "minute");

            res.set({
                hour: now.hour(),
                minute: now.minute(),
                second: 0,
                millisecond: 0
            });

            return res;
        }

        getTitle() { return NotificationRepository.editorDialogOptions.title; }

        getGridOptions(): viewModels.SearchGridOptions {

            var res: viewModels.SearchGridOptions = {
                cols: [
                    { dataField: 'id', caption: cdh.t('data/common/serialNo'), visible: false },
                    //{ dataField: 'sourceUrl', visible: false },
                    //{
                    //    dataField: 'refId',
                    //    visible: false,
                    //    calculateCellValue: (rd) => {
                    //        var refType: string = rd.refType;
                    //        var refId: string = rd.refId;

                    //        if (refType) {
                    //            var [found, def] = refTypes.tryGet(refType);

                    //            if (found) {
                    //                return ko.unwrap(def.format(refId));
                    //            }
                    //            else
                    //                return refType + ": " + refId;

                    //        }

                    //        return refId;
                    //    }
                    //},
                    { dataField: 'subject' },
                    {
                        dataField: 'status', visible: false,
                        customizeText: e => ko.unwrap(getStatusDisplayName(typeof (e.value) == "number" ? e.value : -1))
                    },
                    { dataField: 'schedule', dataType: "datetime", sortOrder: "asc" },
                ],
                commands: ["edit", "delete"]
            };

            var cfg = notificationConfig();
            if (cfg && cfg.isRepetitionEnabled)
                res.cols.push(
                    {
                        dataField: 'repetitionType',
                        caption: cdh.t("data/notifications/repetition"),
                        lookup: { dataSource: notificationRepetitionTypes.values, valueExpr: 'value', displayExpr: 'displayName' }
                    },
                    { dataField: "startDate", dataType: "datetime" },
                    { dataField: "endDate", dataType: "datetime" },
                );

            res.cols.forEach(expandCol);

            return res;

            function expandCol(col: DevExpress.ui.dxDataGridColumn) {
                if (col.dataField && col.caption === undefined)
                    col.caption = t("data/notifications/" + col.dataField);
            }
        }

        prepareDataSourceCommands(ds: viewModels.IDataSourceViewModel<NotificationViewModel, number>) {


            viewModels.bindDatasourceToCallbackCmdHandler(ds, new viewModels.DeleteCommandHandler(this));

            ds.commandHandler.addHandlers(new utils.BasicCommandHandler(this.handleCommands));
        }

        handleCommands(cmd: string, id?: number): boolean {
            if (utils.equalsIgnoreCase(cmd, "edit")) {
                var vm = this.createEditor();

                alert("todo edit notification: " + id);

                return true;
            }
            else if (utils.equalsIgnoreCase(cmd, "delete")) {
                alert("todo delete notification: " + id);

                return true;
            }
            else if (utils.equalsIgnoreCase(cmd, "info")) {
                alert("todo info notification: " + id);

                return true;
            }
            return false;
        }
    }
}